import qs from 'qs';
import lru from 'lru-cache'

const BASE_URI = process.env.REACT_APP_API_URL;

export const API_URL = BASE_URI

const CommonHeaders = {
    'App-Platform': 1
}

const ApiCache = new lru({
    max: 100
})

export class ApiError extends Error {

    code = null;
    message = null;
    data = null;
    apiError = false;
    payment = false;

    constructor(code, message, data=null, apiError=true) {
        super(message);
        this.code = Number(code);
        this.message = message;
        this.data = data;
        this.apiError = apiError;
        if(this.code === 9991) {

            let target = null;
            if(data && data.choice){
                target = data.choice.user_id
            } else if(data && data.reason){
                target = data.reason.user_id
            }

            let paymentReason = null;
            if(data && data.choice){
                paymentReason = data.choice.code
            } else if(data && data.reason){
                paymentReason = data.reason.code
            }

            this.payment = {
                type: 'bronze',
                reason: data.reason,
                choice: data && 'choice' in data ? data.choice : null,
                paymentReason: paymentReason,
                target: target
            }
        } else if(this.code === 9992) {
            this.payment = {
                type: 'credits',
                reason: data.reason,
                paymentReason: data.reason.code,
                target: data.reason.user_id
            }
        }
    }
}

function requestResolve(req, url) {
    return req.then(resp=>{
        return resp.json().then(data=>{
            if(data.success) {
                return data.data;
            } else if(data.error) {
                const { code, message, data: errorData } = data.error;
                throw new ApiError(code, message, errorData);
            } else {
                throw new ApiError(0, 'Bad gataway', {}, false);
            }
        }).catch(err=>{
            if(err.status === undefined) {
                err.status = resp.status;
            }
            throw err;
        })
    }).catch(err=>{
        if(err.status === undefined) {
            err.status = 0;
        }
        if(err.failedUrl === undefined) {
            err.failedUrl = url;
        }
        throw err;
    })
}

function fetchWithRetry(url, fetchOptions, canRetry) {
    const attempt = retried => fetch(url, fetchOptions).catch(err=>{
        if(canRetry && !retried) {
            return new Promise(resolve=>setTimeout(resolve, 700)).then(()=>attempt(true));
        }
        throw err;
    })
    return attempt(false);
}

function request(path, method='GET', body=null) {
    const options = {};
    if(body) {
        if(method === 'POST') {
            options.body = JSON.stringify(body)
        } else {
            path += `?${qs.stringify(body)}`;
        }
    }
    const url = `${BASE_URI}${path}`;
    const req = fetchWithRetry(url, {
        ...options,
        method,
        headers: {
            'Content-type': 'application/json',
            ...CommonHeaders
        },
        credentials: 'include'
    }, method === 'GET')
    return requestResolve(req, url);
}

export function post(path, body) {
    return request(path, 'POST', body);
}

export function get(path, queryParams, cache) {
    if(cache) {
        if(typeof(cache) !== 'object') {
            cache = {}
        }
        if(!('id' in cache)) {
            cache.id = JSON.stringify({ path, queryParams })
        }
        const value = ApiCache.get(cache.id)
        if(value !== undefined) {
            return Promise.resolve(value)
        }
    }
    return request(path, 'GET', queryParams).then(result=>{
        if(cache) {
            ApiCache.set(cache.id, result, cache.expire)
        }
        return result
    });
}

export function postMultipart(path, data) {
    const formData = new FormData();
    Object.keys(data).forEach(key=>{
        if(data[key] !== undefined) {
            formData.append(key, data[key]);
        }
    })
    const url = `${BASE_URI}${path}`;
    const req = fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
            'Accept': 'application/json',
            ...CommonHeaders
        },
        credentials: 'include'
    })
    return requestResolve(req, url)
}